export default function redirectToLogin(redirectPathAfterLogin) {
  const host = window.location.origin;
  window.location.replace(`${host}/entrar?redirect=${encodeURIComponent(redirectPathAfterLogin)}`);
}
